import emoji from "emoji-dictionary"
import CodeFormatter from "../components/CodeFormatter"
import { fs } from "../controls/Constants"

const KariAsync = () => {
    const codeSnippet = 
    `#include <kari.h>
using namespace kari;

void printToScreen();

void setup(){
    Serial.begin(9600);
    kariBegin({9, 8, 7, 6, 5, 4, 3, 2});
}

void loop(){
    kariAsync::execute(
        [](){
            kariSequential({ {9, 8, 7, 6}, "sequential1"});
        },
        1500
    );

    kariAsync::execute(
        [](){
            kariPulse({ {5, 4, 3, 2}, "pulse1"});
        },
        500
    );

    kariAsync::execute(
        [](){
           Serial.println("Task executed after every 3 seconds"); 
        },
        3000
    );
    kariAsync::execute(printToScreen, 2500);
   
}

void printToScreen(){
	Serial.println("This is executed after each 2.5 seconds");
}
    `
    const introduction = 
    `
    The kariAsync class is a cornerstone of the Kari Arduino Library, a powerful tool designed to bring efficiency and reliability to your Arduino projects. 
    In the world of embedded systems, where timely execution and non-blocking operations are crucial,
    kariAsync stands out by providing a robust framework for managing asynchronous tasks.\n
    Imagine the need to execute multiple tasks simultaneously without halting the main program flow. 
    Whether it's sensor data processing, timed events, or communication protocols, kariAsync ensures your Arduino applications run smoothly and responsively. 
    It abstracts the complexities of task scheduling and execution, allowing developers to focus on creating innovative solutions.\n
    By leveraging kariAsync, you can achieve precise timing and seamless task management, making it an indispensable component for IoT applications, robotics, automation, 
    and any project that requires efficient asynchronous operations.
    
    `
    return (
    <>
        <section>
            <h1>{emoji.getUnicode("zap")} kariAsync</h1>
            <h2>Introduction</h2>
            <p className={`text-formatter ${fs}`}>{introduction}</p>
        </section>
        <section>
            <h2>{emoji.getUnicode("wrench")} Key Features</h2>
            <ul className={`list-type-none ${fs}`}>
                <li>{emoji.getUnicode("white_check_mark")} <strong> Non-blocking Execution </strong> - Run tasks asynchronously without disrupting other operations.</li>
                <li>{emoji.getUnicode("white_check_mark")} <strong> Optimized for Performance</strong> - Execute functions at specified time intervals.</li>
                <li>{emoji.getUnicode("white_check_mark")} <strong>Efficient & Lightweight</strong> - Optimized for embedded systems with minimal resource usage.</li>
                <li>{emoji.getUnicode("white_check_mark")} <strong> Ideal for Timed Events</strong> - Perfect for sensor polling, LED flashing, and scheduled actions.</li>
            </ul>
            </section>  
            <h2>{emoji.getUnicode("hammer_and_wrench")} API Reference</h2>
            <CodeFormatter codeSnippet="static void execute(void (*callback)(), unsigned int delay);" />
            <h3>Description:</h3>
                <ul className={`${fs}`}>
                    <li><strong>void (*callback)()</strong> - A pointer to the callback function that is to be executed. 
                    This function should have no parameters and return void.</li>
                    <li><strong>unsigned int delay</strong> - The delay period in milliseconds after which the callback function will be executed.</li>
                </ul>
            <h2>{emoji.getUnicode("hammer")} Basic Usage Example</h2>
            <CodeFormatter codeSnippet={codeSnippet}/>
            <h2>{emoji.getUnicode("rocket")} Why Use kariAsync?</h2>
            <ul className={fs}>
                <li><strong>Eliminates delay() Calls</strong> - Keeps your Arduino responsive while executing timed tasks.</li>
                <li><strong>Ideal for IoT & Real-time Applications</strong> - Execute tasks efficiently in the background.</li>
                <li><strong>Simple & Effective</strong> - Minimal setup with powerful results.</li>
            </ul>
            <p className={fs}>{emoji.getUnicode("warning")} Avoid using the delay() function in kariAsync or in the  void loop generally, as doing so breaks the non-blocking nature of kari.
                <br/>Hence when working with kari you are not allowed to use the delay() function at all cost in the void loop as all operations
                must adhere to kari's nature of asynchronicity.
            </p>

    </>
    )
}

export default KariAsync
